import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react';
import { PaymentTask } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type PaymentTaskContextType = {
  paymentTask?: PaymentTask;
  setPaymentTask: Dispatch<SetStateAction<PaymentTask | undefined>>;
};

export const PaymentTaskContext = createContext<PaymentTaskContextType>({
  paymentTask: undefined,
  setPaymentTask: () => {},
});

export const PaymentTaskProvider = ({ children }: Props) => {
  const [paymentTask, setPaymentTask] = useState<PaymentTask>();

  return <PaymentTaskContext.Provider value={{ paymentTask, setPaymentTask }}>{children}</PaymentTaskContext.Provider>;
};

export const useCurrentPaymentTask = () => {
  return useContext(PaymentTaskContext);
};
